export default function FloatingCTA() {
  return (
    <aside
      aria-label="Hurtig kontakt"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-40 flex flex-col items-end gap-3 pointer-events-auto"
    >
      {/* Email button */}
      <div className="relative group flex items-center">
        <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-lg bg-stone-900/90 backdrop-blur-sm px-3 py-1.5 text-xs font-medium text-white shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 hidden sm:block">
          Send en mail (lars@gribskovsmeden.dk)
        </span>
        <a
          href="mailto:lars@gribskovsmeden.dk"
          aria-label="Send e-mail til Lars Baundal hos Gribskovsmeden"
          className="w-12 h-12 sm:w-13 sm:h-13 rounded-full bg-stone-900 hover:bg-stone-800 text-amber-400 hover:text-amber-300 shadow-lg shadow-stone-950/30 border border-stone-700/80 flex items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2"
        >
          <i className="fa-solid fa-envelope text-lg sm:text-xl" aria-hidden="true"></i>
        </a>
      </div>

      {/* Phone button */}
      <div className="relative group flex items-center">
        <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-lg bg-stone-900/90 backdrop-blur-sm px-3 py-1.5 text-xs font-medium text-white shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 hidden sm:block">
          Ring til os (+45 48 79 68 16)
        </span>
        <a
          href="tel:+4548796816"
          aria-label="Ring til Gribskovsmeden på +45 48 79 68 16"
          className="w-13 h-13 sm:w-14 sm:h-14 rounded-full bg-amber-600 hover:bg-amber-500 text-white shadow-xl shadow-amber-900/30 flex items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 animate-pulse hover:animate-none"
        >
          <i className="fa-solid fa-phone text-lg sm:text-xl" aria-hidden="true"></i>
        </a>
      </div>
    </aside>
  );
}
